export default __webpack_public_path__ + "static/media/Close.2ddbcf1b.png";